import * as timestamp_pb from "google-protobuf/google/protobuf/timestamp_pb";

import { convertTimestamp } from "../../util";
import { AUTHER_CLIENT, getMetaData, getRequestMetadata } from "../index";
const { DeactivateTokenRequest, GetTokensRequest, UpsertTokenMessage, Token } = require("../../protos/auther_pb");

const getTokens = ({ organizationId }) => {
  const request = new GetTokensRequest();
  const sMetadata = getMetaData();

  request.setOrganizationId(organizationId || sMetadata?.orgId);
  request.setIncludeExpired(false);

  return new Promise((resolve, reject) => {
    AUTHER_CLIENT.getTokens(request, getRequestMetadata(), (err, response) => {
      if (err) {
        console.warn("getTokens", err.code, err.message);
        reject(err);
      } else {
        const tokens = response.getTokensList().map((tokenRes) => {
          return convertTokensFromProto(tokenRes.u);
        });
        resolve(tokens);
      }
    });
  });
};

const insertNewToken = async ({ projectId, organizationId }) => {
  const upsertTokenRequest = new UpsertTokenMessage();
  const tokenMessage = new Token();
  const sMetadata = getMetaData();

  tokenMessage.setJwt(null);
  tokenMessage.setOrganizationId(organizationId); // need to be from jwt
  tokenMessage.setCreatorId(sMetadata.userId); // need to be from jwt
  tokenMessage.setProjectId(projectId);

  const ts = new timestamp_pb.Timestamp();
  ts.setSeconds(0);
  ts.setNanos(0);

  tokenMessage.setCreatedAt(ts);
  tokenMessage.setUpdatedAt(ts);
  tokenMessage.setExpireAt(ts);

  upsertTokenRequest.setToken(tokenMessage);

  return new Promise((resolve, reject) => {
    AUTHER_CLIENT.upsertToken(upsertTokenRequest, getRequestMetadata(), (err, response) => {
      if (err) {
        console.warn("upsertTokenRequest", err.code, err.message);
        reject(err);
      } else {
        const token = response.array.map((tokenRes) => convertTokensFromProto(tokenRes));
        resolve(token);
      }
    });
  });
};

const deleteToken = async ({ organizationId, jwt }) => {
  const deleteTokenRequest = new DeactivateTokenRequest();
  deleteTokenRequest.setOrganizationId(organizationId || "a722c0e9-5c7a-4626-bdde-4e2fed986983");
  deleteTokenRequest.setJwt(jwt);

  return new Promise((resolve, reject) => {
    AUTHER_CLIENT.deactivateToken(deleteTokenRequest, getRequestMetadata(), (err) => {
      if (err) {
        console.warn("upsertTokenRequest", err.code, err.message);
        reject(err);
      } else {
        resolve(true);
      }
    });
  });
};

const convertTokensFromProto = (tokenProto) => {
  return {
    jwt: tokenProto[0],
    organizationId: tokenProto[1],
    creatorId: tokenProto[2],
    expirerId: tokenProto[3],
    updaterId: tokenProto[4],
    projectId: tokenProto[5],
    createdAt: convertTimestamp(tokenProto[6]?.[0]),
    updatedAt: convertTimestamp(tokenProto[7]?.[0]),
    expireAt: convertTimestamp(tokenProto[8]?.[0])
  };
};

export { deleteToken, insertNewToken, getTokens };
